import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
// import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';

const authAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'authAPI',
    endpoints: (builder) => ({
      projectAuthentication: builder.mutation({
        query: (credentials) => ({
          // url: '/Authentication/UserLogin', // Replace with your authentication endpoint
          url: 'Authentication/ProjectAuthentication',
          method: 'POST',
          body: transformRequest(credentials)
        }),
        invalidatesTags: ['authentication'],
        transformResponse: transformSucessResponse,
        transformErrorResponse: transformErrorResponse
      }),
  
    }),
  });

export const { useProjectAuthenticationMutation } = authAPI;
export default authAPI;


